let resolveAuthReady;

export const authReadyPromise = new Promise(resolve => {
  resolveAuthReady = resolve;
});

export const markAuthReady = () => resolveAuthReady();
